<template>
    <div
        :class="[
            'vrm-custom-widget-form__parameter-list-item',
            { 'vrm-custom-widget-form__parameter__closed': !open },
        ]"
    >
        <div @click="() => $emit('toggleParameter')">
            <span
                class="vrm-icon"
                :class="yAxisParameter.device ? yAxisParameter.device.iconClass : ''"
            ></span>
            <span :class="{ 'sg-error': hasErrors }">
                {{
                    yAxisParameter.device
                        ? yAxisParameter.device.name
                        : $t('custom_widgets.new_device', { i18nFallback: 'New device' })
                }}
            </span>
            <div>
                <span
                    class="sg-vrm-icon_121_trash-16px"
                    :class="{ 'sg-disabled': busy }"
                    @click.stop="
                        () => {
                            if (!busy) $emit('delete');
                        }
                    "
                ></span>
                <span v-if="!open" class="sg-vrm-icon_058_plus-round-16px"></span>
                <span v-if="open" class="sg-vrm-icon_059_min-round-16px"></span>
            </div>
        </div>
        <div>
            <vrm-icon-dropdown-field
                v-model="yAxisParameter.label"
                class="vrm-custom-widget-form__label-select"
                :title="$t('custom_widgets.color_label', { i18nFallback: 'Color' })"
                :options="options.labels"
                :disabled="busy"
            />
            <vrm-icon-dropdown-field
                v-model="yAxisParameter.device"
                :title="$t('custom_widgets.device_label', { i18nFallback: 'Device' })"
                :class="[
                    'vrm-custom-widget-form__y-parameter-dropdown',
                    'vrm-custom-widget-form__device-dropdown',
                    { 'extend-dropdown': options.devices.length > 5 },
                ]"
                :options="options.devices"
                :search-enabled="true"
                :required="true"
                :disabled="busy"
                data-cy="device-select-field"
                @input="deviceSelected"
            />
            <vrm-dropdown-field
                v-model="yAxisParameter.dataAttribute"
                :title="$t('custom_widgets.parameter_label', { i18nFallback: 'Parameter' })"
                :class="[
                    'vrm-custom-widget-form__y-parameter-dropdown',
                    { 'extend-dropdown': options.dataAttributes.length > 5 },
                ]"
                :options="options.dataAttributes"
                :search-enabled="true"
                :required="true"
                :disabled="busy || !yAxisParameter.device"
                data-cy="parameter-select-field"
            />
            <vrm-axis-configuration-field
                v-if="showAxisConfiguration"
                v-model="yAxisParameter.yAxisProperties"
                class="vrm-custom-widget-form__parameter__axis-configuration"
                :disabled="busy"
            />
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VrmIconDropdownField from '@/vue/components/forms/VrmIconDropdownField.vue';
import VrmDropdownField from '@/vue/components/forms/VrmDropdownField.vue';
import VrmAxisConfigurationField from '@/vue/components/forms/VrmAxisConfigurationField.vue';

@Component({
    components: { VrmAxisConfigurationField, VrmDropdownField, VrmIconDropdownField },
})
export default class YAxisParameter extends Vue {
    @Prop()
    yAxisParameter;
    @Prop()
    options;
    @Prop()
    showAxisConfiguration;
    @Prop()
    busy;
    @Prop()
    open;

    hasErrors = false;

    deviceSelected() {
        this.yAxisParameter.dataAttribute = null;
    }

    vrmValidate() {
        this.hasErrors = false;
        this.$children.forEach(child => this.validateChild(child));
        return !this.hasErrors;
    }

    validateChild(component) {
        if ('vrmValidate' in component) {
            const valid = component.vrmValidate();
            if (!valid) {
                this.hasErrors = true;
            }
        } else {
            component.$children.forEach(child => this.validateChild(child));
        }
    }
}
</script>
